import React, { useContext, useRef } from "react";
import { FileUp } from "lucide-react";
import { useHistory } from "react-router-dom";
import { importXlsxRules } from "../ruleService";
import { TableContext } from "../../index";

function ImportRulesButton({ disabled, handleClose, className = "" }) {

    const history = useHistory();
    const ref = useRef(null);
    const { config, setConfig } = useContext(TableContext);

    const onChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        handleClose && handleClose();

        importXlsxRules(file).then(result => {
            event.target.type = '';
            event.target.type = 'file';
            if (result) {
                setConfig({ ...config, lastUpdated: Date.now() })
                history.go(0);
            }
        });

    };

    return (
        <>
            <button
                type="button"
                className={`btn modal-v2-btn oct-import-rules-popup__action ${className} ${disabled ? 'disabled' : ''}`}
                onClick={disabled ? null : () => ref.current && ref.current.click()}
                disabled={disabled}
            >
                <FileUp className="oct_icon" size={18} />
                <span className="oct-import-rules-popup__action-copy">
                    <span className="oct-import-rules-popup__action-title">Offline Import</span>
                    <span className="oct-import-rules-popup__action-subtitle">Upload rules from an `.xlsx` file</span>
                </span>
            </button>
            <input className="oct_display-none"
                type="file"
                name="file"
                onChange={onChange}
                accept=".xlsx"
                ref={ref} />
        </>
    );

}

export default ImportRulesButton;
